/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_HomeInputs */

const en_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iter Global home`)
};

const pt_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página inicial da Iter Global`)
};

const es_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de inicio de Iter Global`)
};

/**
* | output |
* | --- |
* | "Iter Global home" |
*
* @param {Nav_Aria_HomeInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_home = /** @type {((inputs?: Nav_Aria_HomeInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_HomeInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_nav_aria_home(inputs)
	if (locale === "es") return es_nav_aria_home(inputs)
	return en_nav_aria_home(inputs)
});